export const NICKNAME_TEST_ID = 'Nickname';
export const NICKNAME_FORM_TEST_ID = 'NicknameForm';
export const NICKNAME_INPUT_TEST_ID = 'NicknameInput';
export const NICKNAME_SAVE_TEST_ID = 'NicknameSave';
export const NICKNAME_CANCEL_TEST_ID = 'NicknameCancel';
export const NICKNAME_CONSIGNMENT_ICON_TEST_ID = 'NicknameConsignmentIcon';
export const ANON_TRACKING_NUMBER_TEST_ID = 'AnonTrackingNumber';
export const INLINE_VALIDATION_TEST_ID = 'InlineValidation';
